module.exports = __webpack_public_path__ + "static/assets/56115bec9fe0856489863d5a0fb50be4.png";